var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGiftBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12a.5.5 0 00.5.5H22a1.76 1.76 0 001.75-1.75v-2A1.75 1.75 0 0022 7h-8.5a.5.5 0 00-.5.5zm-9.25.5H11a.5.5 0 00.5-.5V7.5A.5.5 0 0011 7H2A1.75 1.75 0 00.25 8.75v2A1.76 1.76 0 002 12.5zm7.75 2a.5.5 0 00-.5-.5H2.75a.5.5 0 00-.5.5v7.75A1.76 1.76 0 004 24h7a.5.5 0 00.5-.5zm2-.5a.5.5 0 00-.5.5v9a.5.5 0 00.5.5H20a1.76 1.76 0 001.75-1.75V14.5a.5.5 0 00-.5-.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.71A1 1 0 0014 7c1.18-.29 4-1 4.89-1.92A3 3 0 0014.7.86c-.75.76-1.48 3.08-1.92 4.9a1 1 0 00.22.95zm3.08-4.43a1 1 0 111.35 1.35 8.79 8.79 0 01-2.28.93 8.79 8.79 0 01.97-2.28zm-4.36 3.48c-.44-1.82-1.17-4.14-1.92-4.9a3 3 0 10-4.18 4.19c.86.87 3.71 1.63 4.89 1.92a1 1 0 001-.26 1 1 0 00.21-.95zM7 3.63a1 1 0 011.38-1.35 8.79 8.79 0 01.93 2.28A8.79 8.79 0 017 3.63z"
  })));
}

export default SvgGiftBox;